import { useEffect } from "react";
import { Stack } from "@mui/material";
import { Toast } from "./Toast";
import { useToastStore, Toast as ToastType } from "@/store/toastStore";

interface ToastWithAutoHideProps {
  toast: ToastType;
  onClose: () => void;
}

/**
 * Wrapper pour Toast avec auto-hide basé sur la durée du toast
 */
function ToastWithAutoHide({
  toast,
  onClose,
}: ToastWithAutoHideProps): JSX.Element {
  useEffect(() => {
    if (toast.duration && toast.duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, toast.duration);

      return () => clearTimeout(timer);
    }
    return undefined;
  }, [toast.duration, onClose]);

  return (
    <Toast
      open={true}
      message={toast.message}
      type={toast.type}
      onClose={onClose}
    />
  );
}

/**
 * Conteneur pour afficher tous les toasts
 * À placer dans le layout principal
 * Utilise un Stack pour afficher plusieurs toasts empilés
 */
export function ToastContainer(): JSX.Element {
  const toasts = useToastStore((state) => state.toasts);
  const removeToast = useToastStore((state) => state.removeToast);

  if (toasts.length === 0) {
    return <></>;
  }

  return (
    <Stack
      spacing={2}
      sx={{
        position: "fixed",
        bottom: 16,
        right: 16,
        zIndex: 9999,
        maxWidth: 400,
      }}
    >
      {toasts.map((toast) => (
        <ToastWithAutoHide
          key={toast.id}
          toast={toast}
          onClose={() => removeToast(toast.id)}
        />
      ))}
    </Stack>
  );
}
